import whenDomReady from 'when-dom-ready';
import 'slick-carousel';

function initialize() {
  const $container = $('.js-nav-inner');

  if (!$container) {
    return;
  }

  $container.slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    autoplay: false,
    lazyLoad: 'ondemand',
    lazyLoadBuffer: 1,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}

whenDomReady().then(initialize);
